
import React, { useContext } from 'react';

import Context from "../context/context";
import FilterCount from "./FilterCount";



function SideFiltersNavItem(props) {
  const { data, handleClick } = props;
  const { activeFilters } = useContext(Context);

  let selected = false;
  if (data.name === activeFilters.active_side_filter) {
    selected = true;
  }

  return (
    <>
      <div
        className={`side-nav-item ${selected ? "active" : ""}`}
        onClick={() => handleClick()}
      >
        <span className="side-nav-item-title">

          <span className="side-nav-item-counter">{data.title}
            <FilterCount name={data.name} /></span>
          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none">
            <path d="M0.707031 0.707031L6.36389 6.36389L0.707031 12.0207" stroke="white" stroke-width="2" />
          </svg>
        </span>

      </div>
    </>
  )
}

export default SideFiltersNavItem;
